import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { beverageCategories } from "../../pages/BeverageV6/constants/beverage-categories";
import { Icon } from "~/components";
import styles from "./BeveragesGallery.module.css";

export const BeveragesGallery = ({
  categories = [],
  onAddClick,
  hideAddButton = false,
  slotCount = 10,
}) => {
  const scrolContainer = useRef(null);
  const [arrowsActiveElementsCount, setArrowsActiveElementsCount] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [maxScroll, setMaxScroll] = useState(0);

  const allCategories = Array.from({ length: slotCount }, (_, i) => categories[i] ?? null);

  const getImageForCategory = (categoryName) => {
    return beverageCategories.find((beverage) => beverage.name === categoryName)?.icon;
  };

  const scroll = (delta) => {
    if (!scrolContainer?.current) {
      return;
    }

    scrolContainer.current.scrollTo({
      left: scrolContainer.current.scrollLeft + delta,
      behavior: "smooth",
    });
  };

  const scrollLeft = () => {
    scroll(-190);
  };

  const scrollRight = () => {
    scroll(190);
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      setArrowsActiveElementsCount(
        Math.floor(entries[0].target.clientWidth / 170),
      );
      if (scrolContainer.current) {
        setMaxScroll(
          scrolContainer.current.scrollWidth - scrolContainer.current.clientWidth,
        );
      }
    });

    resizeObserver.observe(scrolContainer.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    const container = scrolContainer.current;
    if (!container) {
      return;
    }

    const handleScroll = () => {
      setScrollPosition(container.scrollLeft);
      setMaxScroll(container.scrollWidth - container.clientWidth);
    };

    container.addEventListener("scroll", handleScroll);
    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.beveragesGallery} data-testid="beverage-gallery">
      {!hideAddButton && (
        <button
          data-testid="beverage-add-category"
          onClick={onAddClick}
          className={`${styles.addButton} custom_click_track`}
          data-custom_click_track_value="Beverages|Add Category|internal"
          type="button"
          aria-label="Add category"
        />
      )}
      <div ref={scrolContainer} className={styles.beveragesGalleryInner} data-testid="carousel-viewport">
        {allCategories.map((category, i) => (
          <div
            data-testid={category ? "beverage-selected-category" : "beverage-empty-category"}
            key={i}
            className={`${styles.category} ${category ? styles.activeCategory : ""}`}
          >
            {category ? <img src={getImageForCategory(category)} alt="" /> : null}
          </div>
        ))}
      </div>
      {categories.length > arrowsActiveElementsCount ? (
        <>
          <button
            data-testid="carousel-previous"
            aria-label="Scroll to previous beverages"
            className={clsx(styles.button, styles.buttonLeft, "custom_click_track")}
            data-custom_click_track_value="Beverages|Scroll Left|internal"
            onClick={scrollLeft}
            disabled={scrollPosition <= 0}
            type="button"
          >
            <Icon name="arrowRightNoLine" />
          </button>
          <button
            data-testid="carousel-next"
            aria-label="Scroll to next beverages"
            className={clsx(styles.button, styles.buttonRight, "custom_click_track")}
            data-custom_click_track_value="Beverages|Scroll Right|internal"
            onClick={scrollRight}
            disabled={scrollPosition >= maxScroll}
            type="button"
          >
            <Icon name="arrowRightNoLine" />
          </button>
        </>
      ) : null}
    </div>
  );
};
